/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FolderMenu_viewer = {
    readonly portfolios: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"FolderMenuOption_portfolio">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "FolderMenu_viewer";
};
export type FolderMenu_viewer$data = FolderMenu_viewer;
export type FolderMenu_viewer$key = {
    readonly " $data"?: FolderMenu_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FolderMenu_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FolderMenu_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmMembers",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "portfolios",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        },
        {
          "kind": "Literal",
          "name": "portfolioTypes",
          "value": [
            "FOLDER"
          ]
        },
        {
          "kind": "Literal",
          "name": "sortBy",
          "value": "MODIFIED"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "firmMembers"
        }
      ],
      "concreteType": "PortfoliosConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "PortfoliosEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "FolderMenuOption_portfolio",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '010fc219eebb27f8da829de47fb14ffd';
export default node;
